import {gql, QueryOptions} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {
  CanvasFolderArtifactFileStateQuery,
  CanvasFolderArtifactFileStateQueryVariables,
} from './__generated/CanvasFolderArtifactFileStateQuery';

export const CANVAS_FOLDER_ARTIFACT_FILE_STATE_QUERY: DocumentNode = gql`
  query CanvasFolderArtifactFileStateQuery($canvasFolderArtifactId: StrictString!)
  @skipAudit
  @engComponent(name: CANVAS_CORE) {
    canvasFolderArtifacts(ids: [$canvasFolderArtifactId]) {
      ...CanvasFolderArtifactFileStateGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('CanvasFolderArtifactFileState').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export type CanvasFolderArtifactFileStateGraphQL = ExtractByTypename<
  CanvasFolderArtifactFileStateQuery['canvasFolderArtifacts'][number],
  'CanvasFolderArtifactNode'
>;

export function getCanvasFolderArtifactFileStateQueryOptions(
  canvasFolderArtifactId: string
): QueryOptions<CanvasFolderArtifactFileStateQueryVariables> {
  return {
    query: CANVAS_FOLDER_ARTIFACT_FILE_STATE_QUERY,
    variables: {canvasFolderArtifactId},
  };
}

export function canvasFolderArtifactFileStateDataToAttributes(data: CanvasFolderArtifactFileStateQuery): {
  name?: string;
  editUrl?: string;
  archiveRecord?: ArchiveRecord | null;
} {
  const artifact = data.canvasFolderArtifacts[0];
  return artifact == null || isInaccessible(artifact)
    ? {}
    : {
        name: artifact.name,
        editUrl: artifact.editUrl,
        archiveRecord: artifact.archiveData.archived ? {purpose: artifact.archiveData.purpose ?? ''} : null,
      };
}
